import apiClient from "./client";

// fetch list of SiteDto
export function fetchSites() {
  return apiClient.get("/sites").then((res) => res.data);
}

export function createSite(payload) {
  return apiClient.post("/sites", payload).then((res) => res.data);
}

export function deleteSite(id) {
  return apiClient.delete(`/sites/${id}`);
}
